import React from "react"
import classNames from "classnames"
import { CheckCircleFilled } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation'

// Components
import Button from "../../../../../../components/Button"
import AuthFormPlate from "../../../../components/AuthFormPlate"

// Models
import {SpecializationSelectProps} from "./index"

// Constants
import {Role} from "../../../../../../constants"

const Roles = [
    {
        id: Role.PATIENT,
        title: "patient"
    },
    {
        id: Role.DOCTOR,
        title: "doctor"
    },
]

const RoleSelect = (props: SpecializationSelectProps) => {
    const {className, handleContinue, handleSelect, selected} = props;
    const { t } = useTranslation();

    const handleClick = role => {
        if (role === Role.PATIENT) {
            return
        }

        handleSelect(role)
    }

    return (
        <AuthFormPlate
            title={t('common:auth.you_are')}
            description={t('common:auth.choose_who_you_are')}
        >
            <div className={className}>
                {Roles.map(s => {
                    const isActive = s.id === selected;
                    const isDisabled = s.id === Role.PATIENT

                    return (
                        <div
                            key={s.id}
                            onClick={() => handleClick(s.id)}
                            className={classNames("item", isActive && "item__active", isDisabled && "item__disabled")}
                        >
                            <img
                                alt={s.title}
                                src={`/static/assets/user-types/${s.id.toLowerCase()}.png`}
                                srcSet={`/static/assets/user-types/${s.id.toLowerCase()}.png, 
                             /static/assets/user-types/${s.id.toLowerCase()}@2x.png 2x, 
                             /static/assets/user-types/${s.id.toLowerCase()}@3x.png 3x`}
                            />
                            {isActive && (
                                <CheckCircleFilled />
                            )}
                            <span className="label">
                                {t(`common:${s.title}`)}
                            </span>
                        </div>
                    )
                })}
                <Button
                    block
                    type="primary"
                    onClick={handleContinue}
                    disabled={selected === null}
                >
                    {t('common:continue')}
                </Button>
            </div>
        </AuthFormPlate>
    )
}

export default RoleSelect;